import React from "react";
import logo from "../assets/Logo.svg";
import youtube from "../assets/YouTube Squared.svg";
import Facebook from "../assets/Facebook.svg";
import WhatsApp from "../assets/WhatsApp.svg";
import Telegram from "../assets/Telegram App.svg";
import Instagram from "../assets/Instagram.svg";
import LinkedIn from "../assets/LinkedIn.svg";
import footer from "../assets/footer.png";

const Footer = ({ data }) => {
  const contact = data?.data?.data?.contact;

  const list2 = [
    { name: "صاحب المنصة", link: "#instructors" },
    { name: "لمحة عن المنصة", link: "#overview" },
  ];

  const list3 = [
    { name: "الرئيسية", link: "#" },
    { name: "الأقسام", link: "#sections" },
    { name: "الدورات", link: "#courses" },
  ];

  const socialLinks = [
    { icon: WhatsApp, url: contact?.whatsapp, name: "واتساب" },
    { icon: Facebook, url: contact?.facebook, name: "فيسبوك" },
    { icon: Instagram, url: contact?.instagram, name: "إنستغرام" },
    { icon: Telegram, url: contact?.telegram, name: "تيليجرام" },
    { icon: youtube, url: contact?.youtube, name: "يوتيوب" },
    { icon: LinkedIn, url: contact?.linkedin, name: "لينكدإن" },
  ];

  return (
    <footer
      className="px-6 py-20 pt-20 md:h-[435px] w-full flex flex-col md:flex-row gap-10 items-center justify-between   bg-no-repeat bg-cover bg-center"
      style={{ backgroundImage: "url('/footer.png')" }}
      dir="rtl"
    >
      <div className="flex flex-col pt-24 items-center justify-center gap-2">
        <img src={logo} alt="شعار المنصة" width={200} />
        <div className="w-80 h-[1px] bg-black" />
        <div className="flex justify-center w-1/2">
          <p className="text-center text-wrap md:text-lg text-sm text-[#1F1F1F]">
            © 2023 جميع الحقوق محفوظة. تم التصميم والتطوير بواسطة{" "}
            <span className="font-bold">ICR</span>
          </p>
        </div>
      </div>

      <div className="flex gap-10 md:pt-24  md:gap-20 justify-center items-center flex-row-reverse">
        <ul className="text-center space-y-5 text-white underline">
          {list2.map((item, i) => (
            <li key={i} className="text-lg font-semibold">
              <a href={item.link}>{item.name}</a>
            </li>
          ))}
        </ul>

        <ul className="text-center   space-y-5 text-white underline">
          {list3.map((item, i) => (
            <li key={i} className="text-lg font-semibold">
              <a href={item.link}>{item.name}</a>
            </li>
          ))}
        </ul>
      </div>

      <div className="grid grid-cols-3 md:pt-24 md:grid-cols-2 items-center justify-center gap-4 md:w-1/2  mx-auto mt-4">
        {socialLinks.map(
          (link, idx) =>
            link.url && (
              <a
                key={idx}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 rounded-xl hover:bg-gray-100 transition"
              >
                <img src={link.icon} alt={link.name} className="w-12 h-12" />
                <span className="text-sm md:text-medium font-medium md:flex hidden">{link.url}</span>
              </a>
            )
        )}
      </div>
    </footer>
  );
};

export default Footer;
